import axiosInstance from "./axios";
import NodeaxiosInstance from "./nodeaxios";


// export const userLogin = (body) => {
//     return axiosInstance.post('User/user_login_details', body)
// }

// export const userResendOTP = (body) => {
//     return axiosInstance.post('user/user_resend_otp', body)
// }

// export const userVerifyOTP = (body) => {
//     return axiosInstance.post('user/user_verify_otp', body)
// }

// export const userEmailVerifyOTP = (body) => {
//     return axiosInstance.post('user/user_email_verify_otp', body)
// }

// export const userRegister = (body) => {
//     return axiosInstance.post('user/user_register_details', body)
// }

// export const uploadFamilyMemberImage = (body) => {
//     return axiosInstance.post('user/upload_family_member_image', body)
// }

// export const sendAttachment = (body) => {
//     return axiosInstance.post('user/send_attachment', body)
// }

// export const uploadMyProfileImage = (body) => {
//     return axiosInstance.post('user/upload_myprofile_image', body)
// }

// export const uploadAadharImage = (body) => {
//     return axiosInstance.post('user/upload_aadhar_image', body)
// }

// export const addUserFamilyMember = (body) => {
//     return axiosInstance.post('user/add_user_family_member', body)
// }

// export const userUpdateSingleFamilyMemberDetail = (body) => {
//     return axiosInstance.post('user/user_update_single_family_member_detail', body)
// }

// export const updateProfileDetails = (body) => {
//     return axiosInstance.post('user/update_profile_details', body)
// }

// export const verifyEmailAddress = (body) => {
//     return axiosInstance.post('user/verify_email_address', body)
// }

// export const userAllFamilyMembers = () => {
//     return axiosInstance.post('user/user_all_family_members', {})
// }

// export const userSingleFamilyMemberDetail = (body) => {
//     return axiosInstance.post('user/user_single_family_member_detail', body)
// }

// export const userSinglePetDetail = (body) => {
//     return axiosInstance.post('user/user_single_pet_detail', body)
// }

// export const userSingleVehicleDetail = (body) => {
//     return axiosInstance.post('user/user_single_vehicle_detail', body)
// }

// export const userUpdateSingleVehicleDetail = (body) => {
//     return axiosInstance.post('user/user_update_single_vehicle_detail', body)
// }

// export const deleteFamilyMember = (body) => {
//     return axiosInstance.post('user/delete_family_member', body)
// }

// export const deleteUserPet = (body) => {
//     return axiosInstance.post('user/delete_pet', body)
// }

// export const deleteUserVehicle = (body) => {
//     return axiosInstance.post('user/delete_vehicle', body)
// }

// export const getPetTypes = (body) => {
//     return axiosInstance.post('user/pet_types', body)
// }

// export const uploadPetImage = (body) => {
//     return axiosInstance.post('user/upload_pet_image', body)
// }

// export const addUserPet = (body) => {
//     return axiosInstance.post('user/add_user_pet', body)
// }

// export const userUpdateSinglePetDetail = (body) => {
//     return axiosInstance.post('user/user_update_single_pet_detail', body)
// }

// export const userAllPetsDetail = () => {
//     return axiosInstance.post('user/user_all_pets_detail', {})
// }

// export const getUserAllVehicles = (body) => {
//     return axiosInstance.post('user/user_all_vehicles', body)
// }

// export const uploadVehicleImage = (body) => {
//     return axiosInstance.post('user/upload_vehicle_image', body)
// }

// export const getVehicleTypeAndCategory = (body) => {
//     return axiosInstance.post('user/vehicle_type_and_category', body)
// }

// export const addUserVehicle = (body) => {
//     return axiosInstance.post('user/add_user_vehicle', body)
// }

// export const getMyTransactions = () => {
//     return axiosInstance.post('user/my_transactions', {})
// }

// export const getMyFollowingList = () => {
//     return axiosInstance.post('user/my_following_list', {})
// }

// export const getBookingList = () => {
//     return axiosInstance.post('user/index', {})
// }

// export const getBookingDetails = (body) => {
//     return axiosInstance.post('user/get_booking_details', body)
// }

// export const getMyProfileDetails = () => {
//     return axiosInstance.post('user/my_profile_details', {})
// }

// export const getBulletinDetails = () => {
//     return axiosInstance.post('user/bulletin_details', {})
// }

// export const acceptRescheduleRequest = (body) => {
//     return axiosInstance.post('user/accept_reschedule_request', body)
// }

// export const cancelRescheduleRequest = (body) => {
//     return axiosInstance.post('user/cancel_reschedule_request', body)
// }

// // Search Module Starts
// export const getSearchFilter = () => {
//     return axiosInstance.post('user/get_search_fillter', {})
// }

// export const getSearchHistory = () => {
//     return axiosInstance.post('user/search_history', {})
// }

// export const addSearchHistory = (body) => {
//     return axiosInstance.post('user/add_search_history', body)
// }

// export const clearSearchHistory = () => {
//     return axiosInstance.post('user/clear_search_history', {})
// }

// export const getMyLocations = () => {
//     return axiosInstance.post('user/my_locations', {})
// }

// export const getLocationTypes = () => {
//     return axiosInstance.post('user/location_types', {})
// }

// export const getSearchVendor = (body) => {
//     return NodeaxiosInstance.get('/search', body)
// }
// // Search Module Ends

// export const deleteMyAccount = () => {
//     return axiosInstance.post('user/delete_my_account', {})
// }

// export const getVendorProfile = (body) => {
//     return axiosInstance.post('user/vendor_profile_details', body)
// }
// export const getVendorLoyalty = (body) => {
//     return axiosInstance.post('user/my_vendor_loyalty_points_detail', body)
// }

// export const getVendorProfileWithoutLogin = (body) => {
//     return axiosInstance.post('user/vendor_profile_details_without_login', body)
// }

// export const getVendorServiceDetails = (body) => {
//     return axiosInstance.post('user/vendor_service_detail_new_without_login', body)
// }

// export const cartSelectService = (body) => {
//     return axiosInstance.post('user/cart_select_service_without_login', body)
// }

// export const checkValidCart = (body) => {
//     return axiosInstance.post('user/check_valid_cart', body)
// }

// export const confirmBooking = (body) => {
//     return axiosInstance.post('user/confirm_booking', body)
// }
// export const confirmEditBooking = (body) => {
//     return axiosInstance.post('user/confirm_edit_booking', body)
// }

// export const saveMyLocation = (body) => {
//     return axiosInstance.post('user/save_my_location', body)
// }

// export const updateMySavedLocation = (body) => {
//     return axiosInstance.post('user/update_my_saved_location', body)
// }

// export const removeMySavedLocation = (body) => {
//     return axiosInstance.post('user/remove_my_saved_location', body)
// }

// export const clearRecentLocations = () => {
//     return axiosInstance.post('user/clear_recent_locations', {})
// }

// export const addRecentLocation = (body) => {
//     return axiosInstance.post('user/select_location', body)
// }

// export const getChatList = () => {
//     return axiosInstance.post('user/user_chat_list_details_new', {})
// }

// export const createNewUserVendorChat = (body) => {
//     return axiosInstance.post('user/create_new_user_vendor_chat', body)
// }

// export const userSingleChatDetailsNew = (body) => {
//     return axiosInstance.post('user/user_single_chat_details_new', body)
// }

// export const userBookingChatDetails = (body) => {
//     return axiosInstance.post('user/user_booking_chat_details', body)
// }

// export const userOrderChatDetails = (body) => {
//     return axiosInstance.post('user/user_order_chat_details', body)
// }

// export const userServiceEnquiryChatDetails = (body) => {
//     return axiosInstance.post('user/user_service_enquiry_chat_details', body)
// }

// export const sendChatMessage = (body) => {
//     return axiosInstance.post('user/send_chat_message', body)
// }

// export const sendEnquiryQuestion = (body) => {
//     return axiosInstance.post('user/enquiry_service', body)
// }

// export const userFamilyList = (body) => {
//     return axiosInstance.post('user/user_family_list', body)
// }

// export const userPetsList = (body) => {
//     return axiosInstance.post('user/user_pets_list', body)
// }

// export const userVehiclesList = (body) => {
//     return axiosInstance.post('user/user_vehicles_list', body)
// }

// export const cartSelectPetOrPerson = (body) => {
//     return axiosInstance.post('user/cart_select_pet_or_person', body)
// }

// export const vendorStaffList = (body) => {
//     return axiosInstance.post('user/vendor_staff_list', body)
// }

// export const cartSelectStaff = (body) => {
//     return axiosInstance.post('user/cart_select_staff', body)
// }

// export const serviceTimeSlotDetailsNew = (body) => {
//     return axiosInstance.post('user/service_time_slot_details_new', body)
// }

// export const cartAddServiceTimeslot = (body) => {
//     return axiosInstance.post('user/cart_add_service_timeslot', body)
// }

// export const singleCartDetails = (body) => {
//     return axiosInstance.post('user/single_cart_details', body)
// }

// export const followUnfollowDetails = (body) => {
//     return axiosInstance.post('user/follow_unfollow_details', body)
// }
// // notification count 
// export const notificationCounts = () => {
//     return axiosInstance.post('user/get_notifications_count')
// }

// // Product Module

// export const addRemoveProductCountWithoutLogin = (body) => {
//     return axiosInstance.post('user/products/add_or_remove_product_cart_without_login', body)
// }


// export const getKitchenMembershipList = (params) => {
//     return NodeaxiosInstance.get("kitchen/fetch-membership-tickets",
//         { params: { vendor_id: params.vendor_id, veg_only: params.veg_only } }
//     );
// };











// NEW APIS
// Read at call time, not at module load. This module is imported once per
// page load, so a snapshot taken here is whatever was in storage before the
// user signed in: every call below then keeps picking the -without-login
// endpoint for the rest of the SPA session, which resolves the cart against
// cart.user_id instead of the authenticated user.
const getUserToken = () => {
    try {
        return JSON.parse(localStorage.getItem('user'));
    } catch (err) {
        return null;
    }
};


export const userLogin = (body) => {
    return axiosInstance.post('User/user_login_details', body)
}

export const userResendOTP = (body) => {
    return axiosInstance.post('user/user_resend_otp', body)
}

export const userVerifyOTP = (body) => {
    return axiosInstance.post('user/user_verify_otp', body)
}

export const userRegister = (body) => {
    return axiosInstance.post('user/user_register_details', body)
}

export const uploadFamilyMemberImage = (body) => {
    return NodeaxiosInstance.post('profile/upload-family-member-image', body)
}

export const sendAttachment = (body) => {
    return NodeaxiosInstance.post('message/send-attachment', body)
}

export const uploadMyProfileImage = (body) => {
    return NodeaxiosInstance.post('user/upload-myprofile-image', body)
}

export const uploadAadharImage = (body) => {
    return NodeaxiosInstance.post('profile/upload-aadhar', body)
}

export const addUserFamilyMember = (body) => {
    return NodeaxiosInstance.post('profile/add-family-member', body)
}

export const userUpdateSingleFamilyMemberDetail = (body) => {
    return NodeaxiosInstance.put('profile/update-family-member', body)
}

export const updateProfileDetails = (body) => {
    return NodeaxiosInstance.post('profile/update-profile', body)
}

export const verifyEmailAddress = (body) => {
    return NodeaxiosInstance.post('profile/verify-email-address', body)
}

export const userEmailVerifyOTP = (body) => {
    return NodeaxiosInstance.post('profile/user-email-verify-otp', body)
}

export const userAllFamilyMembers = () => {
    return NodeaxiosInstance.get('profile/all-family-members')
}

export const userSingleFamilyMemberDetail = (body) => {
    return NodeaxiosInstance.get('profile/family-member-detail', { params: body })
}



export const userSingleVehicleDetail = (body) => {
    return NodeaxiosInstance.get('profile/vehicle-detail', body)
}

export const userUpdateSingleVehicleDetail = (body) => {
    return NodeaxiosInstance.put('profile/update-vehicle', body)
}

export const deleteFamilyMember = (body) => {
    return NodeaxiosInstance.delete('profile/delete-family-member', body)
}

export const deleteUserPet = (body) => {
    return NodeaxiosInstance.delete('profile/delete-pet', { data: body })
}

export const deleteUserVehicle = (body) => {
    return NodeaxiosInstance.delete('profile/delete-vehicle', { data: body })
}

export const getPetTypes = () => {
    return NodeaxiosInstance.get('profile/pet-types')
}

export const uploadPetImage = (body) => {
    return NodeaxiosInstance.post('profile/upload-pet-image', body)
}

export const addUserPet = (body) => {
    return NodeaxiosInstance.post('profile/add-pet', body)
}

export const userSinglePetDetail = (body) => {
    return NodeaxiosInstance.get('profile/pet-detail', { params: body })
}

export const userUpdateSinglePetDetail = (body) => {
    return NodeaxiosInstance.put('profile/update-pet', body)
}

export const userAllPetsDetail = () => {
    return NodeaxiosInstance.get('profile/all-pets', {})
}

export const getUserAllVehicles = (body) => {
    return NodeaxiosInstance.get('profile/all-vehicles', body)
}

export const uploadVehicleImage = (body) => {
    return NodeaxiosInstance.post('profile/upload-vehicle-image', body)
}

export const getVehicleTypeAndCategory = () => {
    return NodeaxiosInstance.get('profile/vehicle-type-and-category')
}

export const addUserVehicle = (body) => {
    return NodeaxiosInstance.post('profile/add-vehicle', body)
}

export const getMyTransactions = () => {
    return NodeaxiosInstance.post('wallet/my-transactions', {})
}

export const getMyFollowingList = () => {
    return NodeaxiosInstance.get('profile/following-list', {})
}

export const getBookingList = () => {
    return NodeaxiosInstance.get('service/index', {})
}

export const getBookingDetails = (body) => {
    return NodeaxiosInstance.get('service/booking-details', { params: body })
}

export const getMyProfileDetails = () => {
    return NodeaxiosInstance.get('profile/my-profile')
}

export const getBulletinDetails = () => {
    return NodeaxiosInstance.get('profile/bulletin-details', {})
}

export const acceptRescheduleRequest = (body) => {
    return NodeaxiosInstance.post('service/accept-reschedule-request', body)
}

export const cancelRescheduleRequest = (body) => {
    return NodeaxiosInstance.post('service/cancel-reschedule-request', body)
}

// Search Module Starts
export const getSearchFilter = () => {
    return NodeaxiosInstance.get('/search-filter', {})
}

export const getSearchHistory = () => {
    return NodeaxiosInstance.get('/search-history', )
}

export const addSearchHistory = (body) => {
    return NodeaxiosInstance.post('/add-search-history', body)
}

export const clearSearchHistory = () => {
    return NodeaxiosInstance.post('/clear-search-history', {})
}

export const getMyLocations = () => {
    return NodeaxiosInstance.get('profile/my-locations', {})
}

export const getLocationTypes = () => {
    return NodeaxiosInstance.get('profile/location-types', {})
}

export const getSearchVendor = (body) => {
    return NodeaxiosInstance.get('/search', {params: body})
}
 

export const getSearchProduct = (body) => {
    return NodeaxiosInstance.get('/search-product', {params: body})
}

export const getSearchService = (body) => {
    return NodeaxiosInstance.get('/search-service', {params: body})
}

export const userSelectSearchLocation = () => {
    return NodeaxiosInstance.get('/selected-location')
}

// Search Module Ends

export const deleteMyAccount = () => {
    return NodeaxiosInstance.delete('profile/delete-my-account', {})
}

export const getVendorProfileDetails = (body) => {
    let url = getUserToken()?.user_type == 'User' ? 'profile-details' : 'profile-details-without-login';
    return NodeaxiosInstance.post(`vendor/${url}`, body);

}
export const getVendorLoyalty = (body) => {
    return NodeaxiosInstance.get('profile/my-vendor-loyalty-points-detail', { params: body })
}

export const getVendorProfileWithoutLogin = (body) => {
    return NodeaxiosInstance.post('vendor/profile-details-without-login', body)
}

export const getVendorServiceDetails = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'vendor-services' : 'vendor-services-without-login';
    return NodeaxiosInstance.post(`service/${url}`, body );
}

export const cartSelectService = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'select-service' : 'select-service-without-login';
    return NodeaxiosInstance.post(`service/${url}`,  body );
}

export const checkValidCart = (body) => {
    return  NodeaxiosInstance.post('service/check-valid-cart', body)
}

export const confirmBooking = (body) => {
    return NodeaxiosInstance.post('service/confirm-booking', body)
}
export const confirmEditBooking = (body) => {
    return NodeaxiosInstance.post('service/confirm-edit-booking', body)
}



export const saveMyLocation = (body) => {
    return NodeaxiosInstance.post('profile/save-location', body)
}

export const updateMySavedLocation = (body) => {
    return NodeaxiosInstance.post('profile/update-saved-location', body)
}

export const removeMySavedLocation = (body) => {
    return NodeaxiosInstance.delete('profile/remove-saved-location', { data: body })
}

export const clearRecentLocations = () => {
    return NodeaxiosInstance.delete('profile/clear-recent-locations')

}

export const addRecentLocation = (body) => {
    return NodeaxiosInstance.post('profile/add-recent-location', body)
}
 

export const getChatList = () => {
    return  NodeaxiosInstance.get('message/chats-list', {})
}

export const createNewUserVendorChat = (body) => {
    return  NodeaxiosInstance.post('message/create-new-user-vendor-chat', body)
}

export const userSingleChatDetailsNew = (body) => {
    return NodeaxiosInstance.post('message/chat-details', body)
}

export const userBookingChatDetails = (body) => {
    return NodeaxiosInstance.post('message/booking-chat-details', body)
}

export const userOrderChatDetails = (body) => {
    return NodeaxiosInstance.post('message/order-chat-details', body)
}

export const userServiceEnquiryChatDetails = (body) => {
    return NodeaxiosInstance.post('message/service-enquiry-chat-details', body)
}

export const sendChatMessage = (body) => {
    return NodeaxiosInstance.post('message/send-message', body)
}

export const sendEnquiryQuestion = (body) => {
    return NodeaxiosInstance.post('message/send-enquiry-question', body)
}

export const userFamilyList = (body) => {
    return  NodeaxiosInstance.post('service/user-family-list', body)
}
 
export const userPetsList = (body) => {
    return NodeaxiosInstance.post('service/user-pets-list', body)
}

export const userVehiclesList = (body) => {
    return  NodeaxiosInstance.post('service/user-vehicles-list', body)
}

export const cartSelectPetOrPerson = (body) => {
    return  NodeaxiosInstance.post('service/select-pet-or-person', body)
}

export const vendorStaffList = (body) => {
    return NodeaxiosInstance.post('service/vendor-staff-list', body)
}

export const cartSelectStaff = (body) => {
    return NodeaxiosInstance.post('service/select-staff', body)
}

export const serviceTimeSlotDetails = (body) => {
    return NodeaxiosInstance.post('service/service-time-slots', body)
}

export const cartAddServiceTimeslot = (body) => {
    return NodeaxiosInstance.post('service/add-service-timeslot', body)
}

export const singleCartDetails = (body) => {
    return  NodeaxiosInstance.post('service/cart-details', body)
}

export const getUserBookingLocationList = (body) => {
    return NodeaxiosInstance.post('service/user-locations-list', body)
}

export const selectUserBookingLocation = (body) => {
    return NodeaxiosInstance.post('service/select-location', body)
}


export const followUnfollowDetails = (body) => {
    return NodeaxiosInstance.post('profile/update-follow', body)
}
// notification count 
export const notificationCounts = () => {
    return NodeaxiosInstance.get('profile/get-notifications-count')
}
// Loyalty Module

export const getUserReferralLoyaltyDetails = () => {
    return NodeaxiosInstance.get('profile/my-referral-loyalty-offers-detail')
}

export const getUserVendorLoyaltyDetails = (body) => {
    return NodeaxiosInstance.get('profile/my-vendor-loyalty-offers-detail', { params: body })
}

export const getUserLoyaltyPoints = (body) => {
    return NodeaxiosInstance.get('profile/loyalty-points-detail', { params: body })
}


// Product Module

export const vendorProductsList = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'fetch-paginated-products' : 'fetch-paginated-products-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}
export const vendorProductsAddonList = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'fetch-vendor-product-addons' : 'fetch-vendor-product-addons-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const fetchVendorProductCategoriesList = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'fetch-vendor-categories' : 'fetch-vendor-categories-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const getProductDetails = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'single-product-detail' : 'single-product-detail-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const addOrRemoveProductCart = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'add-or-remove-product-cart' : 'add-or-remove-product-cart-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const getProductCartDetails = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'product-cart' : 'product-cart-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const getProductCheckoutDetails = (body) => {

    let url = getUserToken()?.user_type === 'User' ? 'product-checkout-details' : 'product-checkout-details-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const getProductDeliveryStaffDetails = (body) => {
    let url = getUserToken()?.user_type === 'User' ? 'get-delivery-staff-details' : 'get-delivery-staff-details-without-login';
    return NodeaxiosInstance.post(`product/${url}`, body);
}

export const getUserOrderLocationList = (body) => {
    return NodeaxiosInstance.post('product/user-locations-list', body)
}

export const selectDeliveryLocation = (body) => {
    return NodeaxiosInstance.post('product/select-delivery-location', body)
}

export const getDeliveryTimeSlots = (body) => {
    return NodeaxiosInstance.post('product/get-delivery-time-slots', body)
}

export const productUpdateDeliveryTimeDate = (body) => {
    return NodeaxiosInstance.post('product/delivery-time-date-update', body)
}

export const productConfirmOrder = (body) => {
    return NodeaxiosInstance.post('product/confirm-order', body)
}

export const productConfirmPayment = (body) => {
    return NodeaxiosInstance.post('product/payment-checkout-razorpay', body)
}

export const productConfirmCancelOrder = (body) => {
    return NodeaxiosInstance.post('product/confirm-cancel-order', body)
}

export const vendorProductCouponList =(body)=>{
    return NodeaxiosInstance.post('product/vendor-coupons-list',body)
}

export const applyCoupon=(body)=>{
    return NodeaxiosInstance.post('product/apply-coupon',body)
}

export const userMyCouponList =(body)=>{
    return NodeaxiosInstance.post('product/my-coupons-list',body)
}

export const uploadOrderAudioNote=(body)=>{
    return NodeaxiosInstance.post('product/upload-audio-note',body)
}

export const UpdateDeliveryInstructions=(body)=>{
    return NodeaxiosInstance.post('product/update-delivery-instructions',body)
}
// Product Courier Apis
export const userCancelCourierChargeRequest=(body)=>{
    return NodeaxiosInstance.post('product/user-cancel-courier-charge-request',body)
}

export const productRedeemVendorLoyaltyOrder = (body) => {
    return NodeaxiosInstance.post('product/redeem-vendor-loyalty', body)
}

export const productChangeCartShippingType = (body) => {
    return NodeaxiosInstance.post('product/change-cart-shipping-type', body)
}

export const productConfirmEditOrder = (body) => {
    return NodeaxiosInstance.post('product/confirm-edit-order', body)
}

export const productAssignOrder = (body) => {
    return NodeaxiosInstance.post('product/reassign-order', body)
}

export const productConfirmReassignOrder = (body) => {
    return NodeaxiosInstance.post('product/reassign-order-confirm', body)
}

export const fetchUserOrderDetails = (body) => {
    return NodeaxiosInstance.post('product/get-order-details', body)
}

export const fetchUserOrderRefundDetails = (body) => {
    return NodeaxiosInstance.post('product/get-refund-info', body)
}
 
export const submitProductOrderRating = (body) => {
    return NodeaxiosInstance.post('product/submit-order-rating', body)
}

export const submitPilotOrderRating = (body) => {
    return NodeaxiosInstance.post('product/submit-order-pilot-rating', body)
}

export const userRejectBalancePaymentRequest = (body) => {
    return NodeaxiosInstance.post('product/reject-balance-payment-request', body)
}

export const userOrderRaiseDispute = (body) => {
    return NodeaxiosInstance.post('product/raise-dispute', body)
}

export const userAcceptEditOrderRequest = (body) => {
    return NodeaxiosInstance.post('product/accept-and-edit-order', body)
}

export const userCancelEditOrderRequest = (body) => {
    return NodeaxiosInstance.post('product/user-cancel-edit-order-request', body)
}

export const userCancelChangeDelivery = (body) => {
    return NodeaxiosInstance.post('product/cancel-change-delivery', body)
}

// Merchant offer module
 
export const fetchVendorOfferList = (body) => {
      let url = getUserToken()?.user_type === 'User' ? 'offer-list' : 'offer-list-without-login';
    return NodeaxiosInstance.post(`offer/${url}`, body);
} 

export const fetchVendorOfferDetails = (body) => {
      let url = getUserToken()?.user_type === 'User' ? 'offer-detail' : 'offer-detail-without-login';
    return NodeaxiosInstance.post(`offer/${url}`, body);
} 

export const fetchVendorOfferPriceDetails = (body) => {
      let url = getUserToken()?.user_type === 'User' ? 'offer-price-detail' : 'offer-price-detail-without-login';
    return NodeaxiosInstance.post(`offer/${url}`, body);
}

export const fetchVendorOfferProductList = (body) => {
      let url = getUserToken()?.user_type === 'User' ? 'offer-services-list' : 'offer-services-list-without-login';
    return NodeaxiosInstance.post(`offer/${url}`, body);
} 

export const fetchVendorOfferServiceList = (body) => {
      let url = getUserToken()?.user_type === 'User' ? 'offer-products-list' : 'offer-products-list-login';
    return NodeaxiosInstance.post(`offer/${url}`, body);
}

// Membership


export const fetchVendorMembershipList = (body)=>{
      let url = getUserToken()?.user_type === 'User' ? 'membership-list' : 'membership-list-without-login';
    return NodeaxiosInstance.post(`membership/${url}`, body);
} 

export const fetchVendorMembershipDetails = (body)=>{
      let url = getUserToken()?.user_type === 'User' ? 'membership-detail' : 'membership-detail-without-login';
    return NodeaxiosInstance.post(`membership/${url}`, body);
} 

export const vendorMembershipReviewCheckout = (body)=>{ 
    return NodeaxiosInstance.post('membership/membership-review-checkout', body);
}

export const vendorMembershipConfirmPurchase  = (body)=>{ 
    return NodeaxiosInstance.post('membership/confirm-payment-checkout', body);
}

export const vendorExtendMembershipReviewCheckout = (body)=>{ 
    return NodeaxiosInstance.post('membership/extend-membership-review', body);
}
export const userMyMembershipCardsList = (body)=>{ 
    return NodeaxiosInstance.post('membership/membership-cards', body);
}
export const userMyMembershipCardDetails = (body)=>{ 
    return NodeaxiosInstance.post('membership/membership-card-detail', body);
}


// Order shipping type changes apis 
export const orderChangeDeliveryLocationsList = (body) => {
    return NodeaxiosInstance.post('product/change-delivery-locations-list',body)
}

export const fetchVendorDeliverySettings=(body)=>{
 return NodeaxiosInstance.post('product/fetch-vendor-delivery-settings',body)
}

export const changeOrderShippingType=(body)=>{
    return NodeaxiosInstance.post('product/change-order-shipping',body)
}

export const fetchChangeDeliveryDetails=(body)=>{
 return NodeaxiosInstance.post('product/fetch-change-delivery-details',body)
}

export const orderConfirmChangeDelivery=(body)=>{
    return NodeaxiosInstance.post('product/confirm-change-delivery',body)
}



// Service Module

export const getKitchenMembershipList = (params) => {
    return NodeaxiosInstance.get('kitchen/fetch-membership-tickets',
        { params: { vendor_id: params.vendor_id, veg_only: params.veg_only } }
    );
};

   
// router.post('/vendor-products-list-by-page', auth, vendorProductsListByPage);
 
  
// router.post('/delivery-settings', auth, deliverySettings); 
 
// router.post('/create-order', auth, createOrder); 

// router.post('/fetch-payment-status', auth, fetchPaymentStatus);
     
// router.post('/track-shipping-order', auth, trackShippingOrder);  

// router.post('/add-tip-amount', auth, addTipAmount);
// router.post('/my-function', auth, myFunction);
 
// router.post('/submit-order-deliverer-rating', auth, submitOrderDelivererRating); 

// router.post('/confirm-balance-payment', auth, confirmBalancePayment);
// router.post('/confirm-courier-payment', auth, confirmCourierPayment);
  
// router.post('/user-cancel-courier-charge-request', auth, userCancelCourierChargeRequest);
// router.post('/raise-dispute', auth, raiseDispute);
// router.get('/check-notification', auth, checkNotification);
// router.post('/check-notification-api', auth, checkNotificationApi);
     

// router.post('/check-auto-assign-orders', auth, checkAutoAssignOrders);
// router.post('/get-online-delivery-partners', auth, getOnlineDeliveryPartners);
// router.post('/assign-delivery-partner', auth, assignDeliveryPartner);
// router.post('/assign-order', auth, assignOrder);
// router.post('/check-partner-response', auth, checkPartnerResponse);
// router.post('/reassign-order', auth, reassignOrder);
// router.post('/reassign-order-confirm', auth, reassignOrderConfirm); 

// router.post('/user-cancel-edit-order-request', auth, userCancelEditOrderRequest);
// router.post('/user-get-edit-order-request-detail', auth, userGetEditOrderRequestDetail); 
// router.post('/fetch-porter-delivery-fare', auth, fetchPorterDeliveryFare);
// router.post('/create-porter-order', auth, createPorterOrder);
// router.post('/process-order-async', auth, processOrderAsync);
// router.post('/get-porter-data', auth, getPorterData); 

// router.post('/get-order-delivery-details', auth, getOrderDeliveryDetails);
// router.post('/get-courier-services', auth, getCourierServices);
// router.post('/calculate-products-volume', auth, calculateProductsVolume);
// router.post('/select-courier-delivery', auth, selectCourierDelivery);  
  
// Service Flow apis 
// router.get('/', auth, gerBookings);
// router.get('/index', auth, gerBookings); 

 

// Me
// router.post('/create-chat', auth, createChat);
// router.post('/create-user-vendor-chat', auth, createNewUserVendorChat);
// router.get('/chats-list', auth, userChatListDetailsNew);
// router.post('/chat-details', auth, userSingleChatDetailsNew);
// router.post('/send-message', auth, sendChatMessage);
// router.post('/send-attachment', auth, sendAttachment);

// Vendor profile screen: served by the Node API (legacy-compatible /api/user/* and /api/product/* routes), response shape unchanged.
export const getVendorServiceDetailsNode = (body) => NodeaxiosInstance.post('user/vendor_service_detail_new_without_login', body);
export const getMerchantHistoryNode = (body) => NodeaxiosInstance.post('user/my_merchant_history', body);
export const getVendorProductsNode = (body) => NodeaxiosInstance.post('product/vendor-products-list-without-login', body);
